/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect, useState } from "react"
import { CUSTOM_REPLY_PROPS } from "./interfaces"
import { BetReply, BoardWrapper } from "./CustomReplyStyled"
import Text from "components/text/index"
import { colors } from "lib/colors"
import { ResultComponent } from "components/result/Result"
import { CardStackComponent } from "./CardStack"
import { BetInfoComponent } from "./BetInfo"

const CustomReply = ({
  betReplyResponse,
  precision,
}: CUSTOM_REPLY_PROPS): JSX.Element => {
  const { player, banker, tie, win_seat, currency } = betReplyResponse
  const playerPoints = player?.point
  const bankerPoints = banker?.point
  const [result, setResult] = useState<string>("")

  useEffect(() => {
    setResult(win_seat)
  }, [win_seat])

  const betList = [player, banker, tie]
  const activeBet = betList.filter(item => item.bet !== "0")

  return (
    <>
      <BetReply>
        <BoardWrapper>
          <Text
            size='16px'
            color={colors.secondary}
            fontWeight='bold'
            align='left'
            justify='flex-start'
            marginBottom='20px'
          >
            <>
              <span>Player </span> &nbsp; {playerPoints}
            </>
          </Text>
          <CardStackComponent
            cards={player?.cards || []}
            win={win_seat === "PLAYER"}
            result={result}
          />
        </BoardWrapper>
        <BoardWrapper>
          <Text
            size='16px'
            color={colors.secondary}
            fontWeight='bold'
            justify='flex-start'
            align='left'
            marginBottom='20px'
          >
            <>
              <span>Banker </span> &nbsp; {bankerPoints}
            </>
          </Text>
          <CardStackComponent
            cards={banker?.cards || []}
            win={win_seat === "BANKER"}
            result={result}
          />
        </BoardWrapper>
      </BetReply>
      <ResultComponent
        betInfo={betReplyResponse}
        align='left'
        justify='flex-start'
        betReply={true}
        marginTop='135px'
        marginBottom='59px'
        currency={currency}
        precision={precision}
      />
      <ul>
        {activeBet.map((item: any, i: number) => (
          <li key={i}>
            <BetInfoComponent
              data={item}
              title={item.type}
              currency={currency}
              precision={precision}
            />
          </li>
        ))}
      </ul>
    </>
  )
}

export default CustomReply
